module.exports = require('./flash')



// WEBPACK FOOTER //
// ./src/playbacks/flash/index.js